enum GeolocationPositionErrorStatus {
  PermissionDenied = "PERMISSION_DENIED",
  PositionUnavailable = "POSITION_UNAVAILABLE",
  Timeout = "TIMEOUT",
  Unknown = "UNKNOWN"
}
export interface ClientGeolocationErrorMessages {
  [GeolocationPositionErrorStatus.PermissionDenied]: string;
  [GeolocationPositionErrorStatus.PositionUnavailable]: string;
  [GeolocationPositionErrorStatus.Timeout]: string;
  [GeolocationPositionErrorStatus.Unknown]: string;
}

interface GetUsersLocationSuccess {
  success: true;
  position: {
    lat: number;
    lon: number;
  };
}
interface GetUsersLocationError {
  success: false;
  errorStatus: GeolocationPositionErrorStatus;
}

type GetUsersLocation = GetUsersLocationSuccess | GetUsersLocationError;

export const getUsersLocation = (): Promise<GetUsersLocation> => {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve({
        success: false,
        errorStatus: GeolocationPositionErrorStatus.Unknown
      });
    } else {
      navigator.geolocation.getCurrentPosition(
        (position: GeolocationPosition) => {
          resolve({
            success: true,
            position: {
              lat: position.coords.latitude,
              lon: position.coords.longitude
            }
          });
        },
        (error: GeolocationPositionError) => {
          let errorStatus: GeolocationPositionErrorStatus;
          switch (error.code) {
            case 1:
              errorStatus = GeolocationPositionErrorStatus.PermissionDenied;
              break;
            case 2:
              errorStatus = GeolocationPositionErrorStatus.PositionUnavailable;
              break;
            case 3:
              errorStatus = GeolocationPositionErrorStatus.Timeout;
              break;
            default:
              errorStatus = GeolocationPositionErrorStatus.Unknown;
              break;
          }
          resolve({
            success: false,
            errorStatus
          });
        }
      );
    }
  });
};
